/**
 * Init Product Quantity
 */
const initProductQuantity = ($fieldNumber = $('.js-product-quantity')) => {
    const $input = $fieldNumber.find('.field')
    const $fieldNumberButton = $fieldNumber.find('.js-field-btn');
    const $numberSpan = $fieldNumber.find('.js-quantity-number');
    const inputMin = $input.attr('min');

    $fieldNumberButton.on('click', function(event) {
        const $btn = $(this);
        let inputValue = parseInt($input.val(), 10) || 0;

        if ($btn.hasClass('js-field-decrement')) {
            if ( inputValue != inputMin) {
                inputValue --;
            }
        } else {
            inputValue++;
        }

        $input.val(inputValue);

        $numberSpan.text(inputValue);

        event.preventDefault();
    });
};

initProductQuantity();
